export const apiHelpers = {
  getUrl: (url, params) => {
    Object.keys(params).forEach(key => {
      url = url.replaceAll(`<${key}>`, params[key]);
    });
    return url;
  }
}